<template>
  <el-container class="myContainer">
    <el-aside width="400px" class="myContainer">
      <el-card class="box-card">
        <el-tree :data="dirData" :props="defaultProps" node-key="id"
                 @node-click="nodeClickHandle"
                 default-expand-all highlight-current ref="active"
                 :expand-on-click-node="false" height="900px">

          <template #default="{ node, data }">
            <el-row style="width:100%">
              <el-col :span="20" style="line-height: 32px">{{ node.label }}</el-col>
              <el-col :span="4" justify="end" v-show="currentDir.id == data.id" style="vertical-align: middle">
                <FrameButton v-if="data.level < 7" :key="data.id" :button="addButton" :parentData="data" ></FrameButton>
                <FrameButton v-if="data.level == 0" :key="data.id" :button="impButton" ></FrameButton>
                <div style="height: 32px;display: inline-block;vertical-align: middle;padding-top: 6px;margin-left: 10px">
                  <el-icon v-if="data.level == 0" :size="20" ><Refresh @click="loadDirTree()"/></el-icon>
                </div>

                <FrameButton v-if="data.level > 0" :key="data.id" :button="editButton" :parentData="data" ></FrameButton>
              </el-col>

            </el-row>
          </template>

        </el-tree>

      </el-card>

    </el-aside>
    <el-main class="myContainer">

      <el-card class="box-card">
        <template #header>
          <div class="card-header">
            <span width="100%" class="Dir-name">目录：{{ currentDir.name }}</span>
          </div>
        </template>
        <div>
          <frame-query ref="frameQuery" componentParam="sdy_template" ></frame-query>
        </div>
      </el-card>

    </el-main>
  </el-container>
</template>

<script>

import {Refresh} from '@element-plus/icons-vue'
export default {
  name: "User",
  components: {Refresh},
  data() {
    return {
      addButton:{
        "component": "button",
        "text":true,
        "circle": true,
        "icon_only": true,
        "icon": "el-icon-CirclePlus",
        "click": "jsOpenWindow",
        "window": {"component": "frame/FrameForm", "type": "sys_Dir_add","title":"添加目录","width":800,"height":600}
      },
      editButton:{
        "component": "button",
        "text":true,
        "circle": true,
        "icon_only": true,
        "icon": "el-icon-Edit",
        "click": "jsOpenWindow",
        "window": {"component": "frame/FrameForm", "type": "sys_Dir_edit","title":"编辑目录","width":800,"height":600}
      },
      impButton:{
        "component": "button",
        "text":true,
        "circle": true,
        "icon_only": true,
        "icon": "el-icon-Grid",
        "click": "jsOpenWindow",
        "window": {"component": "frame/FrameForm", "type": "sys_Dir_import","title":"导入目录","width":800,"height":600}
      },
      addData: {parentId: '', name: '', leadDirUserIds: ''},
      dirData: [{id:'ROOT',name:'产品目录', level:0,
        children:[{id:'001',name:'储罐', level:1},{id:'002',name:'槽车', level:1},{id:'003',name:'气瓶', level:1}]}],
      userData: [],
      currentDir: {},
      subPage: 'user',
      editData: {id: '', oldName: '', name: '', leadDirUserIds: ''},
      defaultProps: {
        children: 'children',
        label: 'name',
      }
    }
  },
  methods: {
    //--勾选--
    nodeClickHandle(currentRow) {
      this.currentDir = currentRow;
      this.$refs.frameQuery.search();
    },
    async loadDirTree() {
      /*
      let {data: res} = await this.$axios.get('frame/Dir/getRootTree');
      if (res.code !== 0) {
        this.$message.error('获取目录失败')
        return;
      }

      this.dirData = res.data;*/
    },
    async getUserData() {
      let {data: res} = await this.$axios.get('purchase/getUserData');
      if (res.code !== 0) {
        this.$message.error('获取用户失败')
        return;
      }

      this.userData = res.data;
    }
  },
  created() {
    this.loadDirTree();
    this.getUserData()
  }
}
</script>

<style lang="less" scoped>
@import 'src/global';

.myContainer {
  padding: 5px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Dir-name {
  font-size: @fontSizeXX;
}

.activeButton {
  background-color: #409EFF;
  color: #FFFFFF
}

.scroller::-webkit-scrollbar {
  width: 3px;
}

.scroller::-webkit-scrollbar-track {
  background-color: transparent;
}

.scroller::-webkit-scrollbar-thumb {
  background-color: #C1C1C1;
}

.DirBody {
  border: #ececec solid 1px;
  font-weight: normal;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
  padding: 0 1px 2px;
}

.DirLeft {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  box-sizing: content-box;
}

.DirRight {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: auto;
  width: 100%;
  min-width: 550px;
}

.treeIcon {
  margin-right: 10px
}

.LeftBody {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  padding-top: 10px;
  overflow-y: auto;
}

.flexRow {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.userRights {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 5px 5px 0 5px;
}

.DirUserList {
  padding: 0 20px 10px;
  display: flex;
  flex-direction: column;
}

.DirTitle {
  height: 45px !important;
  line-height: 40px;
  font-size: @fontSizeSS;
}

.DirName {
  white-space: nowrap;
  min-width: 120px;
  margin-right: 30px;
  padding-right: 20px;
  font-size: @fontSizeS;
}

.titleFlex {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.DirEdit {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin: 10px 0;
}

.DirTable {
  border: none;
  width: 100%;
}

.flexRow > .el-menu-item {
  height: 50px;
  line-height: 50px;
}

.buttonGroup {
  margin-left: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.addButton {
  margin-left: 5px !important;
  padding: 9px;
}

.addDir {
  width: 140px;
  margin-right: 5px;
}

.LeftBody ::v-deep(.el-tree-node__expand-icon) {
  width: 15px;
}

.buttonGroup ::v-deep(.el-icon-key) {
  transform: rotate(180deg);
}

.editButton {
  color: lightgrey;
  min-height: 30px;
  padding: 0;
}

.editButton:hover {
  color: #00afff;
}
</style>
<style lang="less">
@import '@/global';

.rightTree > .el-tree-node > .el-tree-node__children {
  display: flex;
  flex-direction: row !important;
}

.rightTree > .el-tree-node > .el-tree-node__content {
  height: 40px;
}

.rightTree > .el-tree-node > .el-tree-node__content > .el-tree-node__label {
  font-size: @fontSizeS;
}

.DirPoper {
  padding: 0 !important;
}

.poperItem {
  color: #409EFF;
  padding: 0 10px;
  height: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.poperItem:hover {
  background: whitesmoke;
}

.textDir {
  font-size: medium;
}
</style>
<style scoped>
.el-tree >>> .el-tree-node__content {
  height: 36px;
}
</style>
